import * as Actions from './performance-deep-dive.actions';
import { IPerformanceDeepDiveState } from './performance-deep-dive.model';
import {PerformanceDeepDiveActionTypes} from "./performance-deep-dive.actions";

export const performanceDeepDiveInitialState: IPerformanceDeepDiveState = {
  isPerformanceDeepDiveActivityLogsLoading: false,
  isPerformanceDeepDiveActivityLogsLoaded: false,
  isPerformanceDeepDiveShiftDayDataLoading: false,
  isPerformanceDeepDiveShiftDayDataLoaded: false,
  activityLogs: [],
};

export function performanceDeepDiveReducer(
  state: IPerformanceDeepDiveState = performanceDeepDiveInitialState,
  action: Actions.PerformanceDeepDiveActions,
): IPerformanceDeepDiveState {
  switch (action.type) {
    case PerformanceDeepDiveActionTypes.ProductionPerformanceDeepDiveShiftDayDataLoading:
      return {
        ...state,
        ...{
          isPerformanceDeepDiveShiftDayDataLoading: true,
          isPerformanceDeepDiveShiftDayDataLoaded: false,
        },
      };
    case PerformanceDeepDiveActionTypes.ProductionPerformanceDeepDiveShiftDayDataLoaded:
      return {
        ...state,
        ...{
          isPerformanceDeepDiveShiftDayDataLoading: false,
          isPerformanceDeepDiveShiftDayDataLoaded: true,
        },
      };
    default:
      return state;
  }
}
